import { calculateDateRangeFilterValue } from '@/routes/utils'
import { ClickEvent } from 'devextreme/ui/button'

export type FormFilterItemDescriptorType = {
  fieldName: string
  placeHolder: string
  valueKeyName: string
  valueDisplayExpr: string
  currentValue?: unknown
  defaultValue?: unknown
  values: unknown[]
  readOnly?: boolean
  composeFilterItem: () => any[] | null
}

export type GenericFilterFormProps = {
  FormItemDescriptors: FormFilterItemDescriptorType[]
  resetFilterClicked: (e: ClickEvent) => void
  filterValueChanged: () => void
}

export const createDateFilterItemDescriptor = (
  refField: string,
  pHolder: string,
  defValue?: string,
): FormFilterItemDescriptorType => {
  return {
    fieldName: refField,
    placeHolder: pHolder,
    valueKeyName: 'periodo',
    defaultValue: defValue,
    valueDisplayExpr: 'periodo',
    values: [
      { periodo: 'Anno corrente' },
      { periodo: 'Ultimi 12 mesi' },
      { periodo: 'Ultimi 6 mesi' },
      { periodo: 'Ultimi 3 mesi' },
      { periodo: 'Ultimo mese solare' },
      { periodo: 'Ultimo mese' },
      { periodo: 'Mese corrente' },
      { periodo: 'Ultima settimana' },
      { periodo: 'Settimana corrente' },
      { periodo: 'Oggi' },
    ],
    composeFilterItem(): any[] | null {
      // console.log('COMPOSING DATE FLT', this.currentValue)
      if (!this.currentValue) return null
      let maxDateFilterValue: Date | null = null
      let minDateFilterValue: Date | null = null
      const { minDate, maxDate } = calculateDateRangeFilterValue(this.currentValue)
      minDateFilterValue = new Date(minDate.toISOString().replace('Z', ''))
      maxDateFilterValue = new Date(maxDate.toISOString().replace('Z', ''))
      return [
        [refField, '<', maxDateFilterValue],
        [refField, '>=', minDateFilterValue],
      ]
    },
  }
}
